import { updateTablebyId } from 'gql/mutations'
import { getDetailsById } from 'gql/query'

export const updateMCQQuestionsOptionId = async (optionDetails: any[], questionId: number, questionUUID: string) => {
  try {
    if (optionDetails && optionDetails.length > 0 && questionId && questionUUID) {
      const newQuestionIdMappedMcqOptions = optionDetails?.map((option: any) => {
        return {
          ...option,
          option_uuid: `${questionId}_${option?.option_uuid}`,
        }
      })
      if (newQuestionIdMappedMcqOptions && newQuestionIdMappedMcqOptions?.length > 0) {
        const updateOptions = await updateTablebyId(questionUUID, newQuestionIdMappedMcqOptions, 'questions', 'id', 'option_details')
        if (updateOptions) {
          return true
        }
      }
      return false
    }
  } catch (err) {
    console.log(err)
    return false
  }
}

export const checkQuestionIdsAreValid=(variantId:any,transiledFromQuestionId:any)=>{
    return new Promise(async(resolve,reject)=>{
      if(variantId || transiledFromQuestionId){
        if(variantId){
          const getQuestionDetailsForVariant = await getDetailsById(variantId,'questions','question_id',`{id}`)
          if(!getQuestionDetailsForVariant || getQuestionDetailsForVariant.length<=0 || !getQuestionDetailsForVariant[0].id){
            resolve(false)
          }
        }
        if(transiledFromQuestionId){
          const getQuestionDetailsForTransilation = await getDetailsById(transiledFromQuestionId,'questions','question_id',`{id}`)
          if(!getQuestionDetailsForTransilation || getQuestionDetailsForTransilation.length<=0 || !getQuestionDetailsForTransilation){
            resolve(false)
          }
        }
        resolve(true)
      }else{
      resolve(true)
      }
  })
  }

